// DOM elements - Countdown display
const countdownDisplay = document.getElementById("countdown-display")
const countdownContainer = document.querySelector(".countdown-container")

// DOM elements - Brackets
const leftBracket = document.querySelector(".left-bracket")
const rightBracket = document.querySelector(".right-bracket")

// DOM elements - Days
const daysBase = document.getElementById("days-base")
const daysRed = document.getElementById("days-red")
const daysCyan = document.getElementById("days-cyan")
const daysGlitchLines = document.getElementById("days-glitch-lines")

// DOM elements - Hours
const hoursBase = document.getElementById("hours-base")
const hoursRed = document.getElementById("hours-red")
const hoursCyan = document.getElementById("hours-cyan")
const hoursGlitchLines = document.getElementById("hours-glitch-lines")

// DOM elements - Minutes
const minutesBase = document.getElementById("minutes-base")
const minutesRed = document.getElementById("minutes-red")
const minutesCyan = document.getElementById("minutes-cyan")
const minutesGlitchLines = document.getElementById("minutes-glitch-lines")

// DOM elements - Seconds
const secondsBase = document.getElementById("seconds-base")
const secondsRed = document.getElementById("seconds-red")
const secondsCyan = document.getElementById("seconds-cyan")
const secondsGlitchLines = document.getElementById("seconds-glitch-lines")

// State variables
let targetDate = null
let countdownInterval = null
let heavyGlitch = false
let mediumGlitch = false
let lightGlitch = false
let textVisible = true
let isExpired = false

// Format number to always have two digits
const formatNumber = (num) => num.toString().padStart(2, "0")

// Get target date from data attribute or use default
function getTargetDate() {
  const dataTargetDate = countdownContainer?.getAttribute("data-target-date")
  if (dataTargetDate) {
    const parsedDate = new Date(dataTargetDate).getTime()
    if (!isNaN(parsedDate)) {
      return parsedDate
    }
  }
  // Fallback to default date (March 30, 2025)
  return new Date("March 30, 2025 00:00:00").getTime()
}

// Calculate time remaining
function calculateTimeRemaining() {
  const now = new Date().getTime()
  const distance = targetDate - now

  if (distance <= 0) {
    // Countdown expired
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: true,
    }
  }

  // Calculate time units
  const days = Math.floor(distance / (1000 * 60 * 60 * 24))
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((distance % (1000 * 60)) / 1000)

  return {
    days,
    hours,
    minutes,
    seconds,
    expired: false,
  }
}

// Update countdown display
function updateCountdown() {
  const timeRemaining = calculateTimeRemaining()

  // Check if countdown has expired
  if (timeRemaining.expired && !isExpired) {
    isExpired = true
    handleCountdownExpired()
    return
  }

  // Update the countdown numbers
  const formattedDays = formatNumber(timeRemaining.days)
  const formattedHours = formatNumber(timeRemaining.hours)
  const formattedMinutes = formatNumber(timeRemaining.minutes)
  const formattedSeconds = formatNumber(timeRemaining.seconds)

  // Update base text
  daysBase.textContent = formattedDays
  hoursBase.textContent = formattedHours
  minutesBase.textContent = formattedMinutes
  secondsBase.textContent = formattedSeconds

  // Update shadow text
  daysRed.textContent = formattedDays
  daysCyan.textContent = formattedDays
  hoursRed.textContent = formattedHours
  hoursCyan.textContent = formattedHours
  minutesRed.textContent = formattedMinutes
  minutesCyan.textContent = formattedMinutes
  secondsRed.textContent = formattedSeconds
  secondsCyan.textContent = formattedSeconds
}

// Handle countdown expired
function handleCountdownExpired() {
  clearInterval(countdownInterval)

  // Create expired message
  const expiredMessage = document.createElement("div")
  expiredMessage.className = "expired-message"
  expiredMessage.textContent = "COUNTDOWN EXPIRED"

  // Insert before the countdown container
  countdownContainer.parentNode.insertBefore(expiredMessage, countdownContainer)

  // Hide the countdown
  countdownContainer.style.display = "none"
}

// Generate random glitch lines for a specific element
function generateGlitchLines(container) {
  // Clear existing lines
  container.innerHTML = ""

  // Generate new lines
  const numberOfLines = 2 + Math.floor(Math.random() * 3) // 2-4 lines

  for (let i = 0; i < numberOfLines; i++) {
    const line = document.createElement("div")
    line.className = "glitch-line"

    // Random position, height, and color
    const top = Math.random() * 100
    const height = 1 + Math.random() * 2
    const colors = ["#ff0000", "#00ff00", "#0000ff", "#ffffff"]
    const color = colors[Math.floor(Math.random() * colors.length)]

    line.style.top = `${top}%`
    line.style.height = `${height}px`
    line.style.backgroundColor = color

    container.appendChild(line)
  }
}

// Apply light glitch effect to an element
function applyLightGlitch(element) {
  // Apply light glitch styles
  element.style.transform = `translate(${Math.random() * 4 - 2}px, ${Math.random() * 3 - 1.5}px)`
}

// Reset light glitch effect
function resetLightGlitch(element) {
  element.style.transform = "none"
}

// Apply medium glitch effect
function applyMediumGlitch() {
  mediumGlitch = true

  // Show RGB split for all units
  daysRed.style.display = "inline-block"
  daysCyan.style.display = "inline-block"
  hoursRed.style.display = "inline-block"
  hoursCyan.style.display = "inline-block"
  minutesRed.style.display = "inline-block"
  minutesCyan.style.display = "inline-block"
  secondsRed.style.display = "inline-block"
  secondsCyan.style.display = "inline-block"

  // Apply medium glitch styles
  daysBase.classList.add("animate-count-shift")
  hoursBase.classList.add("animate-count-shift")
  minutesBase.classList.add("animate-count-shift")
  secondsBase.classList.add("animate-count-shift")
  leftBracket.classList.add("animate-count-shift")
  rightBracket.classList.add("animate-count-shift")

  // Generate glitch lines for a random selection of units
  if (Math.random() > 0.5) generateGlitchLines(daysGlitchLines)
  if (Math.random() > 0.5) generateGlitchLines(hoursGlitchLines)
  if (Math.random() > 0.5) generateGlitchLines(minutesGlitchLines)
  if (Math.random() > 0.5) generateGlitchLines(secondsGlitchLines)

  setTimeout(
    () => {
      mediumGlitch = false

      // Hide RGB split if heavy glitch is not active
      if (!heavyGlitch) {
        daysRed.style.display = "none"
        daysCyan.style.display = "none"
        hoursRed.style.display = "none"
        hoursCyan.style.display = "none"
        minutesRed.style.display = "none"
        minutesCyan.style.display = "none"
        secondsRed.style.display = "none"
        secondsCyan.style.display = "none"

        // Clear glitch lines
        daysGlitchLines.innerHTML = ""
        hoursGlitchLines.innerHTML = ""
        minutesGlitchLines.innerHTML = ""
        secondsGlitchLines.innerHTML = ""
      }

      // Remove medium glitch styles
      daysBase.classList.remove("animate-count-shift")
      hoursBase.classList.remove("animate-count-shift")
      minutesBase.classList.remove("animate-count-shift")
      secondsBase.classList.remove("animate-count-shift")
      leftBracket.classList.remove("animate-count-shift")
      rightBracket.classList.remove("animate-count-shift")
    },
    100 + Math.random() * 150,
  )
}

// Apply heavy glitch effect
function applyHeavyGlitch() {
  heavyGlitch = true

  // Show RGB split for all units
  daysRed.style.display = "inline-block"
  daysCyan.style.display = "inline-block"
  hoursRed.style.display = "inline-block"
  hoursCyan.style.display = "inline-block"
  minutesRed.style.display = "inline-block"
  minutesCyan.style.display = "inline-block"
  secondsRed.style.display = "inline-block"
  secondsCyan.style.display = "inline-block"

  // Apply heavy glitch styles
  daysBase.classList.add("animate-count-corrupt")
  hoursBase.classList.add("animate-count-corrupt")
  minutesBase.classList.add("animate-count-corrupt")
  secondsBase.classList.add("animate-count-corrupt")
  leftBracket.classList.add("animate-count-corrupt")
  rightBracket.classList.add("animate-count-corrupt")

  // Generate glitch lines for all units
  generateGlitchLines(daysGlitchLines)
  generateGlitchLines(hoursGlitchLines)
  generateGlitchLines(minutesGlitchLines)
  generateGlitchLines(secondsGlitchLines)

  setTimeout(
    () => {
      heavyGlitch = false

      // Hide RGB split if medium glitch is not active
      if (!mediumGlitch) {
        daysRed.style.display = "none"
        daysCyan.style.display = "none"
        hoursRed.style.display = "none"
        hoursCyan.style.display = "none"
        minutesRed.style.display = "none"
        minutesCyan.style.display = "none"
        secondsRed.style.display = "none"
        secondsCyan.style.display = "none"

        // Clear glitch lines
        daysGlitchLines.innerHTML = ""
        hoursGlitchLines.innerHTML = ""
        minutesGlitchLines.innerHTML = ""
        secondsGlitchLines.innerHTML = ""
      }

      // Remove heavy glitch styles
      daysBase.classList.remove("animate-count-corrupt")
      hoursBase.classList.remove("animate-count-corrupt")
      minutesBase.classList.remove("animate-count-corrupt")
      secondsBase.classList.remove("animate-count-corrupt")
      leftBracket.classList.remove("animate-count-corrupt")
      rightBracket.classList.remove("animate-count-corrupt")
    },
    150 + Math.random() * 250,
  )
}

// Apply text flicker effect
function applyTextFlicker() {
  if (Math.random() > 0.6) {
    textVisible = false

    // Hide all base elements
    daysBase.classList.add("hidden")
    hoursBase.classList.add("hidden")
    minutesBase.classList.add("hidden")
    secondsBase.classList.add("hidden")
    
    // Randomly hide brackets (50% chance for each)
    if (Math.random() > 0.5) leftBracket.classList.add("hidden")
    if (Math.random() > 0.5) rightBracket.classList.add("hidden")

    setTimeout(
      () => {
        textVisible = true

        // Show all base elements
        daysBase.classList.remove("hidden")
        hoursBase.classList.remove("hidden")
        minutesBase.classList.remove("hidden")
        secondsBase.classList.remove("hidden")
        leftBracket.classList.remove("hidden")
        rightBracket.classList.remove("hidden")
      },
      30 + Math.random() * 70,
    )
  }
}

// Start all glitch effects
function startGlitchEffects() {
  // Light glitch effect (very frequent)
  setInterval(
    () => {
      lightGlitch = true

      // Apply to random elements
      if (Math.random() > 0.5) applyLightGlitch(daysBase)
      if (Math.random() > 0.5) applyLightGlitch(hoursBase)
      if (Math.random() > 0.5) applyLightGlitch(minutesBase)
      if (Math.random() > 0.5) applyLightGlitch(secondsBase)
      if (Math.random() > 0.5) applyLightGlitch(leftBracket)
      if (Math.random() > 0.5) applyLightGlitch(rightBracket)

      setTimeout(
        () => {
          lightGlitch = false

          // Reset all elements
          resetLightGlitch(daysBase)
          resetLightGlitch(hoursBase)
          resetLightGlitch(minutesBase)
          resetLightGlitch(secondsBase)
          resetLightGlitch(leftBracket)
          resetLightGlitch(rightBracket)
        },
        50 + Math.random() * 150,
      )
    },
    100 + Math.random() * 200,
  )

  // Medium glitch effect (frequent)
  setInterval(
    () => {
      if (!isExpired) applyMediumGlitch()
    },
    400 + Math.random() * 800,
  )

  // Heavy glitch effect (occasional)
  setInterval(
    () => {
      if (!isExpired) applyHeavyGlitch()
    },
    1000 + Math.random() * 1500,
  )

  // Text flicker effect
  setInterval(() => {
    if (!isExpired) applyTextFlicker()
  }, 300)
}

// Initialize
document.addEventListener("DOMContentLoaded", () => {
  // Set target date from data attribute
  targetDate = getTargetDate()
  
  // Initial countdown update
  updateCountdown()

  // Start countdown interval
  countdownInterval = setInterval(updateCountdown, 1000)

  // Start glitch effects
  startGlitchEffects()
})

